<template>
  <div class="sidebar-logo-container" :class="{'collapse':true}">
    <transition name="sidebarLogoFade">
      <router-link key="collapse" class="sidebar-logo-link" to="/base/home">
        <img src="@/assets/ik/images/logo.png" class="sidebar-logo">
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  data() {
    return {
      title: this.$store.getters['setting/getTitle']
    }
  },
  watch: {
    imgUrl(val, oldVal) {
      this.imgUrl = val
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  // background-color: #1482f0;
  color: #ffffff;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      vertical-align: middle;
      padding-top: 10px;
      padding-left: 20px;
      height: 40px;
      position: absolute;
      top: 0px;
      left: -14px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      line-height: 40px;
      margin-left: 10px;
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }
}
</style>
